import { render } from "./UserPicks.vue?vue&type=template&id=5855355c&scoped=true"
import script from "./UserPicks.vue?vue&type=script&lang=js"
export * from "./UserPicks.vue?vue&type=script&lang=js"

import "./UserPicks.vue?vue&type=style&index=0&id=5855355c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5855355c"

export default script